import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import MDButton from "../../components/MDButton";
import {assignMemberPerk, getMemberPerks} from "../common/api/InventoryApi";
import DisplayPerk from "../perk/DisplayPerk";
import {Divider} from "@mui/material";
import Grid from "@mui/material/Grid";

export default function ClientAssignPerk({client, show, handleClose, handleSave}) {

  const [context, setContext] = useContext(AppContext);
  const [saving, setSaving] = useState(false);
  const [perks, setPerks] = useState([]);
  const [perksReady, setPerksReady] = useState(false);

  const handleAssignPerk = (perk) => {
    setSaving(true);
    assignMemberPerk(perk, client).then((resp)=>{
      handleSave();
      setSaving(false);
    })
  }

  useEffect(()=> {
    getMemberPerks().then((resp)=>{
      setPerks(resp);
      setPerksReady(true)
    });
  }, []);

  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>

        <Modal.Header closeButton>
          <Modal.Title>Assign Perk</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">

                      {perksReady && perks?.length <= 0 && <>
                        <center>No Perks defined</center>
                      </>}
                      {perks?.map((perk, idx)=> {
                        return (
                          <div className={'d-block'} key={idx}>
                            <Grid container >
                              <Grid item sm={9}>
                                <DisplayPerk key={idx} perk={perk} />
                              </Grid>
                              <Grid item sm={3} justifyContent="flex-end" alignItems="flex-end" sx={{ position: 'relative' }}>
                                <MDButton style={{
                                  float:'right'
                                }} onClick={()=>{
                                  handleAssignPerk(perk)
                                }} color="info" size={"small"}
                                          disabled={saving}>
                                  Save
                                </MDButton>
                              </Grid>

                            </Grid>
                            <Divider />
                          </div>
                        )
                      })}

                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>


        </Modal.Body>
        <Modal.Footer>
          <MDButton onClick={handleClose} color="info" disabled={saving}>
            Close
          </MDButton>
        </Modal.Footer>
    </Modal>
  );
}